const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full py-6 text-center text-xs text-slate-600">
      <p className="mb-0">© {year} EzePulse. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
